const { String } = require('stdlib/String')
const { getDateInstance } = require('./getDateInstance')

/**
 * Visszaadja a megadott dátumból az év-hónap-napot.
 * @example
 * '2016-01-01 01:02:03' -> '2016-01-01'
 * @param {string | number | Date} tmp - Az opcionális paraméter, amiből a dátum rész kell.
 * @returns {string} Az ISO dátum.
 */
module.exports.getDate = function getDate (tmp) {
  const date = getDateInstance(tmp)

  const utcDate = `${ date.getFullYear() }-${ String.pad(date.getMonth() + 1) }-${ String.pad(date.getDate()) }`

  return utcDate
}
